import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/reducers/rootReducer';

const allAdminsSelector = (state: RootState) => state.admin.allAdmins;
const isAllAdminsLoadingSelector = (state: RootState) =>
  state.admin.isAllAdminsLoading;

interface AdminUserOption {
  key: string;
  value: string;
  label: string;
  disabled: boolean;
}

const adminUserOptionsSelector = createSelector(
  allAdminsSelector,
  (adminUsers): AdminUserOption[] => {
    return adminUsers.map((admin) => {
      const adminId = admin.adminId || '';
      const displayName =
        `${admin.firstName || ''} ${admin.lastName || ''}`.trim() || 'Unknown';
      return {
        key: `admin-${adminId}`,
        value: adminId,
        label: displayName,
        disabled: !!admin.isDeleted,
      };
    });
  },
);

const adminUsersNameMapSelector = createSelector(
  allAdminsSelector,
  (adminUsers): Map<string, string> => {
    const map = new Map<string, string>();
    adminUsers.forEach((admin) => {
      if (admin.adminId) {
        const displayName =
          `${admin.firstName || ''} ${admin.lastName || ''}`.trim() ||
          'Unknown';
        map.set(admin.adminId, displayName);
      }
    });
    return map;
  },
);

export {
  allAdminsSelector,
  isAllAdminsLoadingSelector,
  adminUserOptionsSelector,
  adminUsersNameMapSelector,
};
export type { AdminUserOption };

